import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Step {
  name: string;
  clickable?: boolean;
}

export interface StepEvent {
  step: Step;
  index: number;
}

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: false
})
export class StepperComponent {

  @Input() public steps: Step[];
  @Input() public currentStep: number;
  @Output() public clicked = new EventEmitter<StepEvent>();

  public stepClicked(step: Step, index: number): void {
    if (step.clickable) {
      this.clicked.emit({ step, index });
    }
  }

}
